<template>
    <div>
        <mt-cell class="rej-title" title="驳回记录" is-link value="更多" @click.native="getMoreReject"></mt-cell>
        <div v-if="arr.length>0" class="r-cont">
            <div><span style="padding-right:5px;font-size:18px;color:#E14444;">&bull;</span>{{arr[0]['驳回时间']}}<br/><span style="color:#E14444;font-size:14px;">{{arr[0]['驳回内容']}}</span></div>
        </div>
        <dialog-bar v-model="showRejHistory" type="confirm" title="驳回记录" :confirmText="'收起'">
      <div v-if="arr.length>0" style="text-align:left;">
        <div v-for="(rej,ind) in arr" :key="ind">
          <div class="time-mo">
              <div class="time-line">
                <div class="dot"></div>
                <div class="line" v-show="arr.length>0 && ind<arr.length-1"></div>
              </div>
              <div style="padding-bottom:10px;">{{rej['驳回时间']}}<br/><span>{{rej['驳回内容']}}</span></div>
              </div>
        </div>
      </div>
    </dialog-bar>
    </div>
</template>

<script>
import dialog from "@/components/common/dialog.vue";
export default {
    components: {
    "dialog-bar":dialog
  },
  props:{
      arr:{
          type:Array,
          default:[],
      }
  },
  data(){
      return {
          showRejHistory:false
      }
  },
  methods:{
      //获取更多驳回记录
      getMoreReject(){
        this.showRejHistory=true;
      },
  }
}
</script>

<style lang="scss" scoped>
.rej-title >>>.mint-cell-wrapper{padding-left: 0;}
.rej-title >>>.mint-cell-title{
  font-size: 0.83em;
  font-weight: bold;
  color: #2c3e50;
}
.rej-title >>>.mint-cell-value{
  font-size: 0.83em;
  font-weight: bold;
  color: #2c3e50;
}
</style>

<style scoped>
.r-cont{line-height:1.5;padding:5px 10px;background-color: white;}
.rej-title{background-color: transparent;}
.time-mo{display: flex; line-height: 1.5;padding: 10px 0;}
.time-line{display: flex;flex-direction: column;align-items: center;height: auto;}
.line{width: 3px;background-color:  #E14444;flex: 1;border-radius: 2px;}
.dot{width: 10px;height: 10px;border-radius: 50%;background-color:  #E14444;margin:8px 10px 10px;}
</style>


// WEBPACK FOOTER //
// src/components/common/reject.vue